// Recovered compiled webpack factory 58914. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { ShowcaseGrid: () => p });
  var n = r(95155),
    a = r(12115);
  let s = [
      [
        {
          src: "macbook-open",
          aspect: 910 / 512,
          alt: "A MacBook lid opening onto a dark analytics dashboard, against a pale studio backdrop",
        },
        {
          src: "engaging",
          aspect: 910 / 512,
          alt: "A dark resource site for design engineers, presented as a slow camera move across the page",
        },
        {
          src: "evil-charts",
          aspect: 910 / 512,
          alt: "Animated chart components on a light surface",
        },
      ],
      [
        {
          src: "medical-imaging",
          aspect: 910 / 512,
          alt: "Medical imaging software reviewing brain scans on a MacBook, lit by a moving highlight",
        },
        { src: "watch", aspect: 410 / 512, alt: "Watch face UI" },
        { src: "bence", aspect: 910 / 512, alt: "Product interface reveal" },
        { src: "iphone", aspect: 1, alt: "iPhone app screen" },
      ],
      [
        {
          src: "vercel",
          aspect: 910 / 512,
          alt: 'Vercel "Agentic Infrastructure" landing page on a desktop display',
        },
        {
          src: "workout",
          aspect: 410 / 512,
          alt: "A running workout summary on a phone, with heart-rate zones over the session",
        },
        {
          src: "tldr-dashboard",
          aspect: 910 / 512,
          alt: "TLDR streaming dashboard with referral leaderboard, on a laptop",
        },
        { src: "paradigma", aspect: 910 / 512, alt: "Agency site scrolling in a browser frame" },
      ],
    ].map((e) => e.map((e) => ({ ...e, cell: 0.816 * e.aspect }))),
    i = s.flat(),
    l = new Set(["macbook-open", "workout", "medical-imaging", "bence", "vercel", "iphone"]),
    o = i.filter((e) => l.has(e.src)),
    c = Math.max(...s.map((e) => e.reduce((e, t) => e + t.cell, 0))),
    d = Math.max(...s.map((e) => (e.length - 1) * 16)),
    u = `max(150px, calc((100cqw - ${d + 4}px) / ${c.toFixed(4)}))`;
  function m(e) {
    return {
      flexGrow: String(e),
      flexShrink: "1",
      flexBasis: `calc(var(--row-h) * ${e})`,
      maxWidth: `calc(var(--row-h) * ${1.5 * e})`,
      aspectRatio: String(e),
    };
  }
  function h(e) {
    if (e >= 1) return 0;
    let t = 1 - e * e;
    return t * t;
  }
  function p() {
    let e = (0, a.useRef)(null),
      t = (0, a.useRef)(null),
      r = (0, a.useRef)(null),
      l = (0, a.useRef)([]),
      c = (0, a.useRef)([]),
      [d, p] = (0, a.useState)(null),
      [f, v] = (0, a.useState)(!1),
      [b, g] = (0, a.useState)(!1),
      [x, y] = (0, a.useState)(!1),
      [w, k] = (0, a.useState)(-1);
    (0, a.useEffect)(() => {
      let e = window.matchMedia("(hover: hover) and (pointer: fine)"),
        t = window.matchMedia("(prefers-reduced-motion: reduce)"),
        r = window.matchMedia("(max-width: 1023px)"),
        n = () => {
          (v(e.matches), g(t.matches), y(r.matches));
        };
      return (
        n(),
        e.addEventListener("change", n),
        t.addEventListener("change", n),
        r.addEventListener("change", n),
        () => {
          (e.removeEventListener("change", n),
            t.removeEventListener("change", n),
            r.removeEventListener("change", n));
        }
      );
    }, []);
    let j = f && !b && !x,
      N = (0, a.useRef)({ x: 0, y: 0, s: 0 }),
      _ = (0, a.useRef)({ x: 0, y: 0, s: 0 }),
      E = (0, a.useRef)(null),
      M = (0, a.useRef)(null),
      P = (0, a.useRef)(-1),
      L = (0, a.useRef)(null),
      $ = (0, a.useRef)(null),
      R = (0, a.useRef)(-1),
      I = (0, a.useRef)(!1),
      S = (0, a.useCallback)(() => {
        let e = t.current;
        if (!e || I.current || N.current.s > 0.002) return;
        let r = l.current.filter(Boolean);
        if (r.length !== s.length) return;
        let n = r.every((e) => {
          let t = Array.from(e.children);
          if (t.length < 2) return !0;
          let r = t.map((e) => e.offsetTop);
          return Math.max(...r) - Math.min(...r) < Math.min(...t.map((e) => e.offsetHeight)) / 2;
        });
        P.current = e.clientWidth;
        let a = {
          W: e.clientWidth,
          H: e.offsetHeight,
          d: r.map((e) => e.offsetHeight),
          singleLine: n,
        };
        ((E.current = n
          ? (function (e) {
              let t = [],
                r = 0;
              for (let n = 0; n < s.length; n++) (t.push(r + e.d[n] / 2), (r += e.d[n] + 12));
              let n = s.map((t) => e.W - (t.length - 1) * 16),
                a = s.map((e) => e.reduce((e, t) => e + t.cell, 0)),
                i = s.map((e, t) => {
                  let r = 0;
                  return e.map((e) => {
                    let s = (n[t] * e.cell) / a[t],
                      i = r + s / 2;
                    return ((r += s + 16), i);
                  });
                }),
                l = s.map((e, r) => e.map(() => t[r]));
              return {
                rowCentreY: t,
                tileCentreX: i,
                tileCentreY: l,
                innerW: n,
                aSum: a,
                hAvail: e.H - (s.length - 1) * 12,
              };
            })(a)
          : null),
          ($.current = a),
          p(a));
      }, []),
      C = (0, a.useCallback)(() => {
        (L.current && clearTimeout(L.current),
          (L.current = window.setTimeout(() => {
            ((L.current = null), S());
          }, 260)));
      }, [S]);
    (0, a.useEffect)(() => {
      S();
      let e = t.current;
      if (!e) return;
      let r = new ResizeObserver(() => {
        e.clientWidth !== P.current && C();
      });
      return (
        r.observe(e),
        () => {
          (r.disconnect(), L.current && clearTimeout(L.current));
        }
      );
    }, [S, C]);
    let A = (0, a.useCallback)(() => {
        I.current = !1;
        let e = t.current;
        for (let t of (e && (e.style.height = ""), l.current))
          t && ((t.style.height = ""), (t.style.flexWrap = ""));
        c.current.forEach((e, t) => {
          if (!e) return;
          ((e.style.width = ""), (e.style.height = ""), Object.assign(e.style, m(i[t].cell)));
          let r = e.querySelector("video");
          r && (r.style.objectPosition = i[t].focus ?? "");
        });
      }, []),
      z = (0, a.useCallback)(
        (e) => {
          let r = E.current,
            n = $.current;
          if (!r || !n) return;
          let a = _.current,
            i = N.current,
            o = 1 - Math.pow(0.8, e / (1e3 / 60));
          if (
            ((i.x += (a.x - i.x) * o),
            (i.y += (a.y - i.y) * o),
            (i.s += (a.s - i.s) * o),
            i.s < 0.002 && 0 === a.s)
          ) {
            ((i.s = 0), A(), -1 !== R.current && ((R.current = -1), k(-1)));
            return;
          }
          I.current = !0;
          let d = s.map((e, t) => {
              let a = 1 + 0.72 * i.s * h(Math.abs(i.y - r.rowCentreY[t]) / 300);
              return n.d[t] * a;
            }),
            u = d.reduce((e, t) => e + t, 0),
            m = t.current;
          m && (m.style.height = `${n.H}px`);
          let p = -1,
            f = 1 / 0,
            v = 0;
          for (let e = 0; e < s.length; e++) {
            let t = (r.hAvail * d[e]) / u,
              n = l.current[e];
            n && ((n.style.height = `${t}px`), (n.style.flexWrap = "nowrap"));
            let a = s[e].map((t, n) => {
                let a = i.x - r.tileCentreX[e][n],
                  s = i.y - r.tileCentreY[e][n],
                  l = Math.sqrt(a * a + s * s);
                return (l < f && ((f = l), (p = v + n)), t.cell * (1 + i.s * h(l / 420)));
              }),
              o = a.reduce((e, t) => e + t, 0);
            for (let n = 0; n < s[e].length; n++) {
              let s = c.current[v + n];
              if (!s) continue;
              ((s.style.flexGrow = "0"),
                (s.style.flexShrink = "0"),
                (s.style.flexBasis = "auto"),
                (s.style.maxWidth = "none"),
                (s.style.width = `${(r.innerW[e] * a[n]) / o}px`),
                (s.style.height = `${t}px`));
              let l = s.querySelector("video");
              if (l) {
                let t = i.x - r.tileCentreX[e][n],
                  a = i.y - r.tileCentreY[e][n],
                  s = 4 * i.s * h(Math.sqrt(t * t + a * a) / 420),
                  o = 50 - (t / 420) * s,
                  c = 50 - (a / 420) * s;
                l.style.objectPosition = `${o}% ${c}%`;
              }
            }
            v += s[e].length;
          }
          i.s > 0.5 && p !== R.current && ((R.current = p), k(p));
        },
        [A],
      ),
      F = j && (null == d ? void 0 : d.singleLine) === !0;
    ((0, a.useEffect)(() => {
      if (!F) return;
      let e = performance.now(),
        r = (t) => {
          let n = Math.min(t - e, 64);
          ((e = t),
            z(n),
            N.current.s > 0 || _.current.s > 0
              ? (M.current = requestAnimationFrame(r))
              : (M.current = null));
        },
        n = () => {
          null === M.current && ((e = performance.now()), (M.current = requestAnimationFrame(r)));
        },
        a = t.current;
      if (!a) return;
      let s = (e) => {
          let t = a.getBoundingClientRect();
          ((_.current = { x: e.clientX - t.left, y: e.clientY - t.top, s: 1 }),
            0 === N.current.s && ((N.current.x = _.current.x), (N.current.y = _.current.y)),
            n());
        },
        i = () => {
          ((_.current = { ..._.current, s: 0 }), n());
        };
      return (
        a.addEventListener("mousemove", s),
        a.addEventListener("mouseleave", i),
        () => {
          (a.removeEventListener("mousemove", s),
            a.removeEventListener("mouseleave", i),
            null !== M.current && cancelAnimationFrame(M.current),
            (M.current = null),
            (N.current = { x: 0, y: 0, s: 0 }),
            (_.current = { x: 0, y: 0, s: 0 }),
            A());
        }
      );
    }, [F, z, A]),
      (0, a.useEffect)(() => {
        let t = e.current;
        if (!t || b) return;
        let r = new IntersectionObserver(
          (e) => {
            for (let t of e) {
              if (!t.isIntersecting) continue;
              let e = t.target;
              ("none" === e.preload && (e.preload = "metadata"), r.unobserve(e));
            }
          },
          { rootMargin: "200px 0px" },
        );
        for (let e of t.querySelectorAll("video")) r.observe(e);
        return () => r.disconnect();
      }, [b]),
      (0, a.useEffect)(() => {
        let t = e.current;
        if (!t || !j) return;
        let r = Array.from(t.querySelectorAll('video[data-gallery="desktop"]')),
          n = w >= 0 ? i[w].src : null,
          a = () => {
            for (let e of r)
              e.dataset.clip !== n || document.hidden
                ? e.paused || e.pause()
                : e.play().catch(() => {});
          };
        return (
          a(),
          document.addEventListener("visibilitychange", a),
          () => document.removeEventListener("visibilitychange", a)
        );
      }, [j, w]),
      (0, a.useEffect)(() => {
        let t = e.current;
        if (!t || b) return;
        if (x) {
          let e = r.current;
          if (!e) return;
          let n = Array.from(t.querySelectorAll('video[data-gallery="compact"]')),
            a = !1,
            s = () => {
              for (let e of n)
                a && !document.hidden ? e.play().catch(() => {}) : e.paused || e.pause();
            },
            i = new IntersectionObserver(
              (e) => {
                ((a = e[e.length - 1].isIntersecting), s());
              },
              { threshold: 0.1, rootMargin: "100px 0px" },
            );
          return (
            i.observe(e),
            document.addEventListener("visibilitychange", s),
            () => {
              for (let e of (i.disconnect(),
              document.removeEventListener("visibilitychange", s),
              n))
                e.paused || e.pause();
            }
          );
        }
        if (f) return;
        let n = Array.from(t.querySelectorAll('video[data-gallery="desktop"]')),
          a = new Set(),
          s = () => {
            let e = document.hidden;
            for (let t of n) {
              let r = !e && a.has(t);
              r && t.paused ? t.play().catch(() => {}) : r || t.paused || t.pause();
            }
          },
          i = new IntersectionObserver(
            (e) => {
              for (let t of e) {
                let e = t.target;
                t.isIntersecting ? a.add(e) : a.delete(e);
              }
              s();
            },
            { threshold: 0.35, rootMargin: "100px 0px" },
          );
        for (let e of n) i.observe(e);
        return (
          document.addEventListener("visibilitychange", s),
          () => {
            (i.disconnect(), document.removeEventListener("visibilitychange", s));
          }
        );
      }, [x, b, f]));
    let q = -1;
    return (0, n.jsxs)("div", {
      ref: e,
      style: { containerType: "inline-size" },
      children: [
        (0, n.jsx)("div", {
          ref: r,
          className: "grid grid-cols-2 gap-3 sm:grid-cols-3 lg:hidden",
          children: o.map((e) =>
            (0, n.jsx)(
              "div",
              {
                className:
                  "squircle-lg relative aspect-[4/5] overflow-hidden border border-black/[0.08] bg-black/[0.03] dark:border-white/[0.10] dark:bg-white/[0.03]",
                children: (0, n.jsx)("video", {
                  className: "h-full w-full object-cover",
                  style: e.focus ? { objectPosition: e.focus } : void 0,
                  "data-gallery": "compact",
                  "data-clip": e.src,
                  src: `/showcase/${e.src}.mp4`,
                  poster: `/showcase/${e.src}.webp`,
                  "aria-label": e.alt,
                  preload: "none",
                  muted: !0,
                  loop: !0,
                  playsInline: !0,
                  disablePictureInPicture: !0,
                  disableRemotePlayback: !0,
                }),
              },
              e.src,
            ),
          ),
        }),
        (0, n.jsx)("div", {
          ref: t,
          className: "hidden lg:block",
          style: { "--row-h": u },
          children: s.map((e, t) =>
            (0, n.jsx)(
              "div",
              {
                ref: (e) => {
                  l.current[t] = e;
                },
                className: "flex flex-wrap items-center justify-center",
                style: { columnGap: 16, rowGap: 12, marginTop: 12 * (0 !== t) },
                children: e.map((e) => {
                  let t = (q += 1);
                  return (0, n.jsx)(
                    "div",
                    {
                      ref: (e) => {
                        c.current[t] = e;
                      },
                      className:
                        "squircle-lg relative overflow-hidden border border-black/[0.08] bg-black/[0.03] dark:border-white/[0.10] dark:bg-white/[0.03]",
                      style: m(e.cell),
                      children: (0, n.jsx)("video", {
                        className: "h-full w-full object-cover",
                        style: e.focus ? { objectPosition: e.focus } : void 0,
                        "data-gallery": "desktop",
                        "data-clip": e.src,
                        src: `/showcase/${e.src}.mp4`,
                        poster: `/showcase/${e.src}.webp`,
                        "aria-label": e.alt,
                        preload: "none",
                        muted: !0,
                        loop: !0,
                        playsInline: !0,
                        disablePictureInPicture: !0,
                        disableRemotePlayback: !0,
                      }),
                    },
                    e.src,
                  );
                }),
              },
              t,
            ),
          ),
        }),
      ],
    });
  }
}
